import { render, staticRenderFns } from "./CanvasFloor.vue?vue&type=template&id=0e10606d"
import script from "./CanvasFloor.vue?vue&type=script&lang=js"
export * from "./CanvasFloor.vue?vue&type=script&lang=js"
import style0 from "./CanvasFloor.vue?vue&type=style&index=0&id=0e10606d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports